
































import { ElTable } from "element-ui/types/table";
import { ExpressionOperatorKinds, IDateCalculateItem, IDateComparisonExpressionContent } from "../../../../../../../documaker/domain/format/objects";
import { Component, Emit, Mixins, Prop, Watch } from "vue-property-decorator";
import { StandardOption } from "../../../../../../../base/components/system/selectors/mixins";
import { OptionDropDownSelector } from "../../../../../../../base/components/system";

@Component({
  components: {
    OptionDropDownSelector,
  },
})
export default class DateComparisonExpressionSelector extends Mixins() {
  @Prop({ default: false })
  shouldShowIndex: boolean;

  @Prop({ default: false })
  shouldShowOperator: boolean;

  @Prop({ default: () => [] as IDateComparisonExpressionContent[] })
  items: IDateComparisonExpressionContent[];

  $refs!: {
    table: ElTable,
  };

  get operatorOption(): StandardOption<ExpressionOperatorKinds>[] {
    const options = [] as StandardOption<ExpressionOperatorKinds>[];
    return options.concat(new StandardOption<ExpressionOperatorKinds>("より大きい時", ExpressionOperatorKinds.LessThan))
      .concat(new StandardOption<ExpressionOperatorKinds>("以上の時", ExpressionOperatorKinds.LessThanOrEqualTo))
      .concat(new StandardOption<ExpressionOperatorKinds>("より小さい時", ExpressionOperatorKinds.GreaterThan))
      .concat(new StandardOption<ExpressionOperatorKinds>("以下の時", ExpressionOperatorKinds.GreaterThanOrEqualTo))
      .concat(new StandardOption<ExpressionOperatorKinds>("と等しい時", ExpressionOperatorKinds.Euqal))
      .concat(new StandardOption<ExpressionOperatorKinds>("以外の時", ExpressionOperatorKinds.NotEqual));
  }

  toName(row: IDateComparisonExpressionContent): string {
    return row.name;
  }

  toId(row: IDateComparisonExpressionContent): number {
    return row.reference.id;
  }

  @Watch("items")
  onItemsUpdated(newValue: IDateCalculateItem[], oldValue: IDateCalculateItem[]) {
    // element-uiのテーブルにスクロールバーが表示される際、ヘッダがずれる問題に対応するため、dataプロパティ更新時に遅延でdoLayoutを呼び出す
    this.$nextTick(() => this.$doWhenValid(t => t.doLayout(), this.$refs.table));
  }

  @Emit()
  selectionChange(value: IDateCalculateItem[]): void {}
}
